<template>

    <v-flex :xs12="vista != 'NA'" :sm12="vista != 'NA'" :md4="vista != 'NA'">

        <v-card style="background-color: transparent !important" width="100%">
            <v-card flat class="text-xs-center ma-3">
                <v-card-title class=" primary">
                    <span class="card-title-text" style="color: white; font-size:small"><v-icon size="14" color="white">
                            mdi-account </v-icon> ASEGURADO</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-form ref="form" v-model="validForm" lazy-validation>

                    <v-card-text>
                        <v-col md="12">


                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Delitos</h4>
                            <v-row>
                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.svdpa" :class="classdisabled" label="Daños"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svlesiones" :class="classdisabled" label="Lesiones"
                                        style="margin: 0px" @change="datos.lclave = null" hide-details></v-checkbox>
                                    <v-radio-group v-model="datos.lclave" :error-messages="validation.errorLesiones"
                                        :class="classdisabled" v-if="datos.svlesiones"
                                        style="margin: -1px; margin-left: 15px;">
                                        <v-radio label="Ambulatorias" value="1"></v-radio>
                                        <v-radio label="Hospitalización" value="2"></v-radio>
                                    </v-radio-group>

                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.svrobo" :class="classdisabled" label="Robo"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svhomicidios" :class="classdisabled" label="Homicidio"
                                        style="margin: 0px" hide-details></v-checkbox>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.svavgc" :class="classdisabled" label="AVGC"
                                        style="margin: 0px" hide-details></v-checkbox>
                                </v-col>

                            </v-row>
                        </v-col>
                        <div v-if="validation.errorDelitos">
                            <span class='spanError' style="color:red;font-size:12px">Indique al menos una opción</span>
                            <br />
                        </div>

                        <v-col v-if="vista == 'AJ' || vista == 'AB' || vista == 'VJ'" md="12">


                            <h6 class="text-info" style="color: #2196f3;">Agravantes</h6>
                            <v-row>
                                <v-col>
                                    <v-checkbox v-model="datos.svebriedad" :class="classdisabled"
                                        label="Estado de ebriedad" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svfuga" :class="classdisabled"
                                        label="Abandono de víctima / fuga" style="margin: 0px"
                                        hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svdrogas" :class="classdisabled"
                                        label="Drogas o estupefacientes" style="margin: 0px" hide-details></v-checkbox>
                                </v-col>

                            </v-row>



                        </v-col>

                        <v-col v-if="vista == 'NA'" md="12">


                            <h6 class="text-info" style="color: #2196f3;">Agravantes</h6>
                            <v-row>

                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.svebriedad" :class="classdisabled"
                                        label="Estado de ebriedad" style="margin: 0px" hide-details></v-checkbox>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.svfuga" :class="classdisabled"
                                        label="Abandono de víctima / fuga" style="margin: 0px"
                                        hide-details></v-checkbox>
                                </v-col>
                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.svdrogas" :class="classdisabled"
                                        label="Drogas o estupefacientes" style="margin: 0px" hide-details></v-checkbox>
                                </v-col>

                            </v-row>


                        </v-col>


                        <v-col v-if="vista == 'NA'" md="12">
                            <h6 class="text-info" style="color: #2196f3; ">Tipo Accidente</h6>
                            <v-row>

                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.spaascortecirc" :class="classdisabled"
                                        label="Corte de circulación" style="margin: 0px" hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.spaasperdcontrol" :class="classdisabled"
                                        label="Pérdida de control" style="margin: 0px" hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.spaasalcancesimple" :class="classdisabled"
                                        label="Alcance simple" style="margin: 0px" hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.spaasatropello" :class="classdisabled" label="Atropello"
                                        style="margin: 0px" hide-details></v-checkbox>
                                </v-col>

                                <v-col cols="6" sm="4" md="4">
                                    <v-checkbox v-model="datos.spaascrucero" :class="classdisabled"
                                        label="Preferencia de paso (crucero o intersección)" style="margin: 0px"
                                        hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.spaasinvcarril" :class="classdisabled"
                                        label="Invasión de carril" style="margin: 0px" hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.spaasotro" :class="classdisabled" label="Otro"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-textarea @input="uppercase('spaasotrotaobs')"
                                        v-on:blur="datos.spaasotrotaobs = datos.spaasotrotaobs != null ? datos.spaasotrotaobs.trim() : null"
                                        :counter="255" :rules="rulestextareaOtro" outlined
                                        rows="2" :error-messages="validation.errorOtro" :disabled="editObs"
                                        :filled="editObs" v-model="datos.spaasotrotaobs"></v-textarea>
                                </v-col>

                                <v-col cols="6" sm="4" md="4">

                                    <v-checkbox v-model="datos.spaasalcancecp" :class="classdisabled"
                                        label="Alcance con proyección" style="margin: 0px" hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.spaasmreversa" :class="classdisabled"
                                        label="Maniobras de reversa" style="margin: 0px" hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.spaaspda" :class="classdisabled" @change="cambioPasada()"
                                        label="Pasada de alto" style="margin: 0px" hide-details></v-checkbox>
                                    <v-col v-if="datos.spaaspda">
                                        <strong>Cruce con:</strong>
                                        <multiselect v-model="datos.pdaclave"
                                            deselect-label="No se puede remover el valor seleccionado" :disabled="edit"
                                            selected-label="Seleccionado" select-label="Seleccione Cruce con"
                                            track-by="pdaclave" label="pdamotivo" placeholder="Seleccione una opción"
                                            :options="opcionesPasadaAlto" :allow-empty="false">
                                        </multiselect>
                                        <!--validacion-->
                                        <div v-if="validation.errorCrucecon">
                                            <span class='spanError' style="color:red;font-size:12px">Indique una
                                                opción</span>
                                            <br />
                                        </div>
                                        <strong>Testigos:</strong>
                                        <v-radio-group row v-model="datos.spaaspdatestigos"
                                            :error-messages="validation.errorTestigos" @change="cambioTestigos()" inline
                                            :class="classdisabled" style="margin: -1px; margin-left: 15px;">
                                            <v-radio label="Sí" :value="1"></v-radio>
                                            <v-radio label="No" :value="0"></v-radio>
                                        </v-radio-group>

                                        <v-row v-if="datos.spaaspdatestigos == '1'">

                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.spaaspdatestigosocupante"
                                                    :class="classdisabled" label="Ocupantes" style="margin: 0px"
                                                    hide-details>

                                                </v-checkbox>
                                            </v-col>

                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.spaaspdatestigosexterno"
                                                    :class="classdisabled" label="Externos" style="margin: 0px"
                                                    hide-details>

                                                </v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <!--validacion-->
                                        <div v-if="validation.errorTestigosExtra">
                                            <span class='spanError' style="color:red;font-size:12px">Indique una
                                                opción</span>
                                            <br />
                                        </div>

                                        <strong>Cámaras:</strong>
                                        <v-radio-group row v-model="datos.spaaspdacamaras"
                                            :error-messages="validation.errorCamaras" @change="cambioCamaras()" inline
                                            :class="classdisabled" style="margin: -1px; margin-left: 15px;">
                                            <v-radio label="Sí" :value="1"></v-radio>
                                            <v-radio label="No" :value="0"></v-radio>
                                        </v-radio-group>
                                        <v-row v-if="datos.spaaspdacamaras == '1'">
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.spaaspdacamarastransito"
                                                    :class="classdisabled" label="Transito" style="margin: 0px"
                                                    hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.spaaspdacamarasparticular"
                                                    :class="classdisabled" label="Particulares" style="margin: 0px"
                                                    hide-details></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <!--validacion-->
                                        <div v-if="validation.errorCamarasExtra">
                                            <span class='spanError' style="color:red;font-size:12px">Indique una
                                                opción</span>
                                            <br />
                                        </div>

                                    </v-col>
                                </v-col>
                            </v-row>
                        </v-col>


                        <v-col v-if="vista == 'AB'" md="12">

                            <h6 class="text-info" style="color: #2196f3; ">Tipo Accidente</h6>
                            <v-row>
                                <v-col>
                                    <v-checkbox v-model="datos.spaabcortecirc" :class="classdisabled"
                                        label="Corte de circulación" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.spaabcrucero" :class="classdisabled"
                                        label="Preferencia de paso (crucero o intersección)" style="margin: 0px"
                                        hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.spaabpda" :class="classdisabled" @change="cambioPasada()"
                                        label="Pasada de alto" style="margin: 0px" hide-details></v-checkbox>
                                    <v-col v-if="datos.spaabpda">
                                        <strong>Cruce con:</strong>
                                        <multiselect v-model="datos.pdaclave"
                                            deselect-label="No se puede remover el valor seleccionado" :disabled="edit"
                                            selected-label="Seleccionado" select-label="Seleccione Cruce con"
                                            track-by="pdaclave" label="pdamotivo" placeholder="Seleccione una opción"
                                            :options="opcionesPasadaAlto" :allow-empty="false">
                                        </multiselect>
                                        <!--validacion-->
                                        <div v-if="validation.errorCrucecon">
                                            <span class='spanError' style="color:red;font-size:12px">Indique una
                                                opción</span>
                                            <br />
                                        </div>
                                        <strong>Testigos:</strong>

                                        <v-radio-group row v-model="datos.spaabpdatestigos"
                                            :error-messages="validation.errorTestigos" @change="cambioTestigos()" inline
                                            :class="classdisabled" style="margin: -1px; margin-left: 15px;">
                                            <v-radio label="Sí" :value="1"></v-radio>
                                            <v-radio label="No" :value="0"></v-radio>
                                        </v-radio-group>
                                        <v-row v-if="datos.spaabpdatestigos == '1'">
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.spaabpdatestigosocupante"
                                                    :class="classdisabled" label="Ocupantes" style="margin: 0px"
                                                    hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.spaabpdatestigosexterno"
                                                    :class="classdisabled" label="Externos" style="margin: 0px"
                                                    hide-details></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <!--validacion-->
                                        <div v-if="validation.errorTestigosExtra">
                                            <span class='spanError' style="color:red;font-size:12px">Indique una
                                                opción</span>
                                            <br />
                                        </div>

                                        <strong>Cámaras:</strong>

                                        <v-radio-group row v-model="datos.spaabpdacamaras"
                                            :error-messages="validation.errorCamaras" @change="cambioCamaras()" inline
                                            :class="classdisabled" style="margin: -1px; margin-left: 15px;">
                                            <v-radio label="Sí" :value="1"></v-radio>
                                            <v-radio label="No" :value="0"></v-radio>
                                        </v-radio-group>

                                        <v-row v-if="datos.spaabpdacamaras == '1'">
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.spaabpdacamarastransito"
                                                    :class="classdisabled" label="Transito" style="margin: 0px"
                                                    hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.spaabpdacamarasparticular"
                                                    :class="classdisabled" label="Particulares" style="margin: 0px"
                                                    hide-details></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <!--validacion-->
                                        <div v-if="validation.errorCamarasExtra">
                                            <span class='spanError' style="color:red;font-size:12px">Indique una
                                                opción</span>
                                            <br />
                                        </div>

                                    </v-col>
                                    <v-checkbox v-model="datos.spaabperdcontrol" :class="classdisabled"
                                        label="Pérdida de control" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.spaabinvcarril" :class="classdisabled"
                                        label="Invasión de carril" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.saincorp" :class="classdisabled" label="Incorporación"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.spaabalcancecp" :class="classdisabled"
                                        label="Alcance con proyección" style="margin: 0px" hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.spaabalcancesimple" :class="classdisabled"
                                        label="Alcance simple" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.spaabalcancesa" :class="classdisabled"
                                        label="Alcance por alcance" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.spaabmreversa" :class="classdisabled"
                                        label="Maniobras de reversa" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.spaabatropello" :class="classdisabled" label="Atropello"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.spaabotros" :class="classdisabled" label="Otro"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-textarea @input="uppercase('spaabotrotaobs')"
                                        v-on:blur="datos.spaabotrotaobs = datos.spaabotrotaobs != null ? datos.spaabotrotaobs.trim() : null"
                                        :counter="255" :rules="rulestextareaOtro" outlined
                                        :error-messages="validation.errorOtro" rows="2" :disabled="editObs"
                                        :filled="editObs" v-model="datos.spaabotrotaobs"></v-textarea>

                                </v-col>

                            </v-row>
                        </v-col>


                        <v-col v-if="vista == 'AJ' || vista == 'VJ'" md="12">

                            <h6 class="text-info" style="color: #2196f3; ">Tipo Accidente</h6>
                            <v-row>
                                <v-col>
                                    <v-checkbox v-model="datos.svcortedc" :class="classdisabled"
                                        label="Corte de circulación" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svpreferenciadp" :class="classdisabled"
                                        label="Preferencia de paso (crucero o intersección)" style="margin: 0px"
                                        hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svpasadada" :class="classdisabled"
                                        @change="cambioPasada()" label="Pasada de alto" style="margin: 0px"
                                        hide-details></v-checkbox>
                                    <v-col v-if="datos.svpasadada">
                                        <strong>Cruce con:</strong>
                                        <multiselect v-model="datos.pdaclave"
                                            deselect-label="No se puede remover el valor seleccionado" :disabled="edit"
                                            selected-label="Seleccionado" select-label="Seleccione Cruce con"
                                            track-by="pdaclave" label="pdamotivo" placeholder="Seleccione una opción"
                                            :options="opcionesPasadaAlto" :allow-empty="false">
                                        </multiselect>
                                        <!--validacion-->
                                        <div v-if="validation.errorCrucecon">
                                            <span class='spanError' style="color:red;font-size:12px">Indique una
                                                opción</span>
                                            <br />
                                        </div>
                                        <strong>Testigos:</strong>
                                        <v-radio-group row v-model="datos.pdatestigos"
                                            :error-messages="validation.errorTestigos" @change="cambioTestigos()" inline
                                            :class="classdisabled" style="margin: -1px; margin-left: 15px;">
                                            <v-radio label="Sí" :value="'1'"></v-radio>
                                            <v-radio label="No" :value="'0'"></v-radio>
                                        </v-radio-group>

                                        <v-row v-if="datos.pdatestigos == '1'">
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.pdatestigosocupante" :class="classdisabled"
                                                    label="Ocupantes" style="margin: 0px" hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.pdatestigosexterno" :class="classdisabled"
                                                    label="Externos" style="margin: 0px" hide-details></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <!--validacion-->
                                        <div v-if="validation.errorTestigosExtra">
                                            <span class='spanError' style="color:red;font-size:12px">Indique una
                                                opción</span>
                                            <br />
                                        </div>

                                        <strong>Cámaras:</strong>
                                        <v-radio-group row v-model="datos.pdacamaras"
                                            :error-messages="validation.errorCamaras" @change="cambioCamaras()" inline
                                            :class="classdisabled" style="margin: -1px; margin-left: 15px;">
                                            <v-radio label="Sí" value="1"></v-radio>
                                            <v-radio label="No" value="0"></v-radio>
                                        </v-radio-group>
                                        <v-row v-if="datos.pdacamaras == '1'">
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.pdacamarastransito" :class="classdisabled"
                                                    label="Transito" style="margin: 0px" hide-details></v-checkbox>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="6">
                                                <v-checkbox v-model="datos.pdacamarasparticular" :class="classdisabled"
                                                    label="Particulares" style="margin: 0px" hide-details></v-checkbox>
                                            </v-col>
                                        </v-row>
                                        <!--validacion-->
                                        <div v-if="validation.errorCamarasExtra">
                                            <span class='spanError' style="color:red;font-size:12px">Indique una
                                                opción</span>
                                            <br />
                                        </div>

                                    </v-col>
                                    <v-checkbox v-model="datos.svperdidadc" :class="classdisabled"
                                        label="Pérdida de control" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svinvanciondc" :class="classdisabled"
                                        label="Invasión de carril" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.saincorp" :class="classdisabled" label="Incorporación"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svalcancecp" :class="classdisabled"
                                        label="Alcance con proyección" style="margin: 0px" hide-details></v-checkbox>

                                    <v-checkbox v-model="datos.svalcances" :class="classdisabled" label="Alcance simple"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svalcancepa" :class="classdisabled"
                                        label="Alcance por alcance" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svmaniobrasdr" :class="classdisabled"
                                        label="Maniobras de reversa" style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svatropello" :class="classdisabled" label="Atropello"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-checkbox v-model="datos.svotrata" :class="classdisabled" label="Otro"
                                        style="margin: 0px" hide-details></v-checkbox>
                                    <v-textarea @input="uppercase('datos.svotrotaobs')"
                                        v-on:blur="datos.svotrotaobs = datos.svotrotaobs != null ? datos.svotrotaobs.trim() : null"
                                        :counter="255" :rules="rulestextareaOtro"
                                        :error-messages="validation.errorOtro" outlined rows="2" :disabled="editObs"
                                        :filled="editObs" v-model="datos.svotrotaobs"></v-textarea>

                                </v-col>

                            </v-row>
                        </v-col>

                    </v-card-text>
                    <v-divider></v-divider>


                    <v-card-text v-if="vista == 'AJ'">
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Responsabilidad por parte de
                            </h4>
                            <p style="font-weight: bold;">De conformidad al criterio del ajustador, el responsable es:
                            </p>

                            <v-row>
                                <v-col md="12">
                                    <v-radio-group v-model="datos.spaajresponsabilidad" :class="classdisabled"
                                        :error-messages="validation.errorResponsabilidad">
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-radio label="Asegurado" value="NA"></v-radio>
                                                <v-radio label="Corresponsabilidad" value="CO"></v-radio>
                                                <v-radio label="Tercero" value="TR"></v-radio>

                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-radio label="Golpe Fuga" value="GF"></v-radio>
                                                <v-radio label="No se puede determinar" value="ND"></v-radio>

                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </v-col>

                            </v-row>
                            <br />
                            <v-textarea @input="uppercase('spaajdetporque')"
                                v-on:blur="datos.spaajdetporque = datos.spaajdetporque != null ? datos.spaajdetporque.trim() : null"
                                :counter="255" :rules="rulestextareaDet" outlined rows="2"
                                :error-messages="validation.errorResponsabilidadPorque" :disabled="editPorque"
                                :filled="editPorque" v-model="datos.spaajdetporque"></v-textarea>


                        </v-col>

                    </v-card-text>


                    <v-card-text v-if="vista == 'AB'">
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Responsabilidad por parte de
                            </h4>
                            <p style="font-weight: bold;">De conformidad al criterio del ajustador, el responsable es:
                            </p>

                            <v-row>
                                <v-col md="12">
                                    <v-radio-group v-model="datos.spaabresponsabilidad" :class="classdisabled"
                                        :error-messages="validation.errorResponsabilidad">
                                        <v-row>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-radio label="Asegurado" value="NA"></v-radio>
                                                <v-radio label="Corresponsabilidad" value="CO"></v-radio>
                                                <v-radio label="Tercero" value="TR"></v-radio>

                                            </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                                <v-radio label="Golpe Fuga" value="GF"></v-radio>
                                                <v-radio label="No se puede determinar" value="ND"></v-radio>

                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </v-col>

                            </v-row>
                            <br />
                            <v-textarea @input="uppercase('spaabdetporque')"
                                v-on:blur="datos.spaabdetporque = datos.spaabdetporque != null ? datos.spaabdetporque.trim() : null"
                                :counter="255" :rules="rulestextareaDet" outlined rows="2"
                                :error-messages="validation.errorResponsabilidadPorque" :disabled="editPorque"
                                :filled="editPorque" v-model="datos.spaabdetporque"></v-textarea>

                        </v-col>

                    </v-card-text>

                    <v-card-text v-if="vista == 'AB'">

                        <v-divider></v-divider>

                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Conductor Detenido</h4>

                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="datos.svconlib" :error-messages="validation.conductor"
                                        :class="classdisabled">
                                        <v-radio label="Sí" :value="false"></v-radio>
                                        <v-radio label="No" :value="true"></v-radio>

                                    </v-radio-group>

                                </v-col>

                            </v-row>

                        </v-col>

                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-text>
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Datos proporcionados por el
                                ajustador (obligatorio)</h4>

                            <div v-if="vista == 'AJ'">
                                <span style="font-weight: bold;">Número de siniestro:</span>
                                <v-text-field v-model="datos.svnumsin"
                                    v-on:blur="datos.svnumsin = datos.svnumsin != null ? datos.svnumsin.trim() : null"
                                    outlined dense :disabled="edit" :class="classdisabled"
                                    :rules="regex != '' ? ObtenerRegex() : [rules.required]"
                                    :filled="edit"></v-text-field>
                            </div>

                            <div v-if="vista == 'AJ' || vista == 'AB' || vista == 'VJ'">
                                <v-checkbox v-model="datos.svcondicionado" :class="classdisabled"
                                    label="El siniestro quedó condicionado" style="margin: 0px"
                                    hide-details></v-checkbox>

                                <v-textarea @input="uppercase('svcondporque')"
                                    v-on:blur="datos.svcondporque = datos.svcondporque != null ? datos.svcondporque.trim() : null"
                                    :counter="255" :rules="rulestextareaCond" outlined
                                    rows="2" :error-messages="validation.errorsvcondporque" :disabled="editCond"
                                    :filled="editCond" v-model="datos.svcondporque"></v-textarea>

                            </div>

                            <div v-if="vista == 'AJ' || vista == 'AB' || vista == 'VJ'">
                                <span style="font-weight: bold;">Marca:</span>
                                <v-text-field v-model="datos.svmarca"
                                    v-on:blur="datos.svmarca = datos.svmarca != null ? datos.svmarca.trim() : null"
                                    outlined dense :disabled="edit" :rules="rulesInputs(1, 20)" :class="classdisabled"
                                    :filled="edit"></v-text-field>
                                <span style="font-weight: bold;">Color:</span>
                                <v-text-field v-model="datos.svcolor"
                                    v-on:blur="datos.svcolor = datos.svcolor != null ? datos.svcolor.trim() : null"
                                    outlined dense :disabled="edit" :rules="rulesInputs(1, 15)" :class="classdisabled"
                                    :filled="edit"></v-text-field>
                                <span style="font-weight: bold;">No.Licencia:</span>
                                <v-text-field v-model="datos.svlicencia"
                                    v-on:blur="datos.svlicencia = datos.svlicencia != null ? datos.svlicencia.trim() : null"
                                    outlined dense :error-messages="validation.errorLicencia"
                                    :rules="rulesInputs(3, 16)" :disabled="edit" :filled="edit"></v-text-field>
                                <span style="font-weight: bold;">Modelo:</span>
                                <v-text-field v-model="datos.svmodelo"
                                    v-on:blur="datos.svmodelo = datos.svmodelo != null ? datos.svmodelo.trim() : null"
                                    outlined dense :disabled="edit" :rules="rulesInputs(1, 30)" :class="classdisabled"
                                    :filled="edit"></v-text-field>
                                <span style="font-weight: bold;">Placas:</span>
                                <v-text-field v-model="datos.svplaca"
                                    v-on:blur="datos.svplaca = datos.svplaca != null ? datos.svplaca.trim() : null"
                                    outlined dense :disabled="edit" :error-messages="validation.errorPlaca"
                                    :rules="rulesInputs(3, 15)" :class="classdisabled" :filled="edit"></v-text-field>
                                <!--<br />-->
                            </div>

                            <div v-if="vista == 'NA'">

                                <v-row>
                                    <v-col cols="6" md="6">
                                        <span style="font-weight: bold;">Marca:</span>
                                        <v-text-field v-model="datos.svmarca"
                                            v-on:blur="datos.svmarca = datos.svmarca != null ? datos.svmarca.trim() : null"
                                            outlined dense :disabled="edit" :rules="rulesInputs(1, 20)"
                                            :class="classdisabled" :filled="edit"></v-text-field>
                                    </v-col>

                                    <v-col cols="6" md="6">
                                        <span style="font-weight: bold;">Color:</span>
                                        <v-text-field v-model="datos.svcolor"
                                            v-on:blur="datos.svcolor = datos.svcolor != null ? datos.svcolor.trim() : null"
                                            outlined dense :disabled="edit" :rules="rulesInputs(1, 15)"
                                            :class="classdisabled" :filled="edit"></v-text-field>
                                    </v-col>
                                </v-row>


                                <v-row>
                                    <v-col cols="6" md="6">
                                        <span style="font-weight: bold;">No.Licencia:</span>
                                        <v-text-field v-model="datos.svlicencia"
                                            v-on:blur="datos.svlicencia = datos.svlicencia != null ? datos.svlicencia.trim() : null"
                                            outlined dense :error-messages="validation.errorLicencia"
                                            :rules="rulesInputs(3, 16)" :disabled="edit" :filled="edit"></v-text-field>
                                    </v-col>

                                    <v-col cols="6" md="6">
                                        <span style="font-weight: bold;">Modelo:</span>
                                        <v-text-field v-model="datos.svmodelo"
                                            v-on:blur="datos.svmodelo = datos.svmodelo != null ? datos.svmodelo.trim() : null"
                                            outlined dense :disabled="edit" :rules="rulesInputs(1, 30)"
                                            :class="classdisabled" :filled="edit"></v-text-field>
                                    </v-col>
                                </v-row>


                                <v-row>
                                    <v-col cols="6" md="6">
                                        <span style="font-weight: bold;">Placas:</span>
                                        <v-text-field v-model="datos.svplaca"
                                            v-on:blur="datos.svplaca = datos.svplaca != null ? datos.svplaca.trim() : null"
                                            outlined dense :disabled="edit" :error-messages="validation.errorPlaca"
                                            :rules="rulesInputs(3, 15)" :class="classdisabled"
                                            :filled="edit"></v-text-field>
                                    </v-col>


                                </v-row>

                                <!--<br />-->
                            </div>


                            <div v-if="vista == 'AJ' || vista == 'VJ'">
                                <span style="font-weight: bold;">Monto de daños del vehículo asegurado:</span>

                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <span style="font-weight: bold;">Monto del deducible:</span>
                                        <v-text-field v-model="datos.svdeducible" outlined dense
                                            :rules="rulesInputsNumber" @keypress="ruleMoney($event, datos.svdeducible)"
                                            :disabled="edit" :filled="edit"></v-text-field>
                                        <span style="font-weight: bold;">Pérdida total:</span>
                                        <v-text-field v-model="datos.svperdidatotal" outlined dense
                                            :rules="rulesInputsNumber"
                                            @keypress="ruleMoney($event, datos.svperdidatotal)" :disabled="edit"
                                            :filled="edit"></v-text-field>
                                        <span style="font-weight: bold;">Estimado de daños:</span>
                                        <v-text-field v-model="datos.svestdanosveh" outlined dense
                                            :rules="rulesInputsNumberDanios" :error-messages="validation.errorEstDanos"
                                            @keypress="ruleMoneyDanios($event, datos.svestdanosveh)" :disabled="edit"
                                            :filled="edit"></v-text-field>

                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <span style="font-weight: bold;">Tipo de Cobertura:</span>
                                        <multiselect v-model="datos.dacobertura" deselect-label="No se puede remover"
                                            :disabled="edit" selected-label="Seleccionado"
                                            select-label="Seleccione Cobertura" track-by="dacobertura" label="text"
                                            placeholder="" :options="opcionesCobertura" :allow-empty="false">
                                        </multiselect>
                                        <!--validacion-->
                                        <div v-if="validation.errorCobertura">
                                            <span class='spanError' style="color:red;font-size:12px">Seleccione el tipo
                                                de cobertura</span>
                                        </div>
                                        <br />
                                        <v-checkbox v-model="datos.svrevisapoliza" label="Póliza Revisada"
                                            :class="classdisabled" :error-messages="validation.errorPoliza"
                                            style="margin: 0px"></v-checkbox>
                                        <br />



                                    </v-col>

                                </v-row>

                            </div>
                        </v-col>

                    </v-card-text>

                    <v-divider></v-divider>


                    <v-divider></v-divider>
                    <v-card-text v-if="vista == 'AJ'">
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Estado físico del asegurado
                            </h4>

                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="datos.saedofisicoNA"
                                        :error-messages="validation.errorEstadoFisico" :class="classdisabled">
                                        <v-radio label="Ileso" value="Ileso"></v-radio>
                                        <v-radio label="Lesionado" value="Lesionado"></v-radio>

                                        <div v-if="datos.saedofisicoNA == 'Lesionado'">
                                            <h4 class="text-info" style="color: #2196f3; font-size: 16px; ">El conductor
                                                está hospitalizado:</h4>
                                            <v-radio-group v-model="datos.sahospitalNA"
                                                :error-messages="validation.errorHospitalNA" :class="classdisabled"
                                                style="margin: -1px; margin-left: 15px;">

                                                <v-radio label="Sí" :value="true"></v-radio>
                                                <v-radio label="No" :value="false"></v-radio>
                                            </v-radio-group>
                                        </div>


                                        <v-radio label="Falleció" value="Fallecio"></v-radio>

                                    </v-radio-group>

                                </v-col>




                            </v-row>

                        </v-col>

                    </v-card-text>

                    <v-divider></v-divider>
                    <v-card-text v-if="vista == 'AJ'">
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Estado del Conductor</h4>
                            <v-row>
                                <v-col md="12">

                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <span style="font-weight: bold;">Está Detenido:</span>


                                            <v-radio-group v-model="datos.salibNA"
                                                :error-messages="validation.errorEstaDetenido" :class="classdisabled">
                                                <v-radio label="Sí" :value="true"></v-radio>
                                                <v-radio label="No" :value="false"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <span style="font-weight: bold;">Falleció:</span>
                                            <v-radio-group v-model="datos.sacondfallecio"
                                                :error-messages="validation.errorConFallecio" :class="classdisabled">
                                                <v-radio label="Sí" :value="true"></v-radio>
                                                <v-radio label="No" :value="false"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>

                                </v-col>

                            </v-row>



                        </v-col>

                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text>

                        <v-row>
                            <v-col md="6">
                                <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Tipo de asegurado</h4>


                                <v-col>
                                    <v-radio-group v-model="datos.asvip" :error-messages="validation.errorTipoAseg"
                                        :class="classdisabled">
                                        <v-radio label="Común" :value="true"></v-radio>
                                        <v-radio label="VIP" :value="false"></v-radio>

                                    </v-radio-group>

                                </v-col>

                            </v-col>


                            <v-col v-if="vista == 'NA'" cols="6">
                                <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">¿Es empresa?</h4>

                                <v-col>
                                    <v-radio-group v-model="datos.saresponsable"
                                        :error-messages="validation.errorTipoEmpresa" :class="classdisabled">
                                        <v-radio label="Sí" :value="'1'"></v-radio>
                                        <v-radio label="No" :value="'2'"></v-radio>

                                    </v-radio-group>

                                </v-col>


                            </v-col>
                        </v-row>







                    </v-card-text>
                    <v-divider></v-divider>



                    <v-card-text v-if="vista == 'NA'">
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Personalidad del conductor
                            </h4>

                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="datos.paclaveas"
                                        :error-messages="validation.errorPersonalidad" :class="classdisabled">
                                        <v-radio label="Tranquilo" :value="1"></v-radio>
                                        <v-radio label="Medianamente complejo" :value="2"></v-radio>
                                        <v-radio label="Complejo" :value="3"></v-radio>
                                        <v-radio label="Muy Complejo" :value="4"></v-radio>
                                    </v-radio-group>

                                </v-col>

                            </v-row>

                        </v-col>

                        <v-divider></v-divider>
                    </v-card-text>

                    <v-card-text v-if="vista == 'AB'">
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Personalidad del conductor
                            </h4>

                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="datos.paclaveab"
                                        :error-messages="validation.errorPersonalidad" :class="classdisabled">
                                        <v-radio label="Tranquilo" :value="1"></v-radio>
                                        <v-radio label="Medianamente complejo" :value="2"></v-radio>
                                        <v-radio label="Complejo" :value="3"></v-radio>
                                        <v-radio label="Muy Complejo" :value="4"></v-radio>
                                    </v-radio-group>

                                </v-col>

                            </v-row>

                        </v-col>

                        <v-divider></v-divider>
                    </v-card-text>


                    <v-card-text v-if="vista == 'AB'">
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Autoridad Competente</h4>

                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="datos.saautoridad"
                                        :error-messages="validation.errorAutoridad" :class="classdisabled">
                                        <v-radio label="Tránsito" value="TR"></v-radio>
                                        <v-radio label="Guardia Nacional" value="GN"></v-radio>
                                        <v-radio label="Ministerio Público" value="MP"></v-radio>
                                        <v-radio label="Juez Cívico" value="JC"></v-radio>
                                        <v-radio label="Sin autoridad" value="SA"></v-radio>
                                    </v-radio-group>

                                </v-col>

                            </v-row>

                        </v-col>

                        <v-divider></v-divider>
                    </v-card-text>


                    <v-card-text v-if="vista != 'VJ'">
                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">NA tiene testigos</h4>

                            <v-row>
                                <v-col>
                                    <v-radio-group v-model="datos.satestigos" :class="classdisabled">
                                        <v-radio label="Sí" :value="true"></v-radio>
                                        <v-radio label="No" :value="false"></v-radio>

                                    </v-radio-group>

                                </v-col>

                            </v-row>

                        </v-col>

                    </v-card-text>


                    <v-card-text v-if="datos.pcnombre != null && vista != 'AB'">

                        <v-divider></v-divider>

                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Posible Conclusión</h4>



                            <h4 class="bg-warning-inverse" style="font-size: 18px; color: #ef6c00; ">
                                {{ this.datos.pcnombre }}</h4>



                        </v-col>

                    </v-card-text>


                    <v-card-text v-if="vista == 'NA'">

                        <v-divider v-if="vista == 'NA'"></v-divider>

                        <v-col md="12">
                            <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Correo electrónico</h4>


                            <span style="font-weight: bold;">Correo electrónico:</span>



                            <v-text-field v-model="datos.svemail" outlined dense
                                :rules="rulesInputsEmail(datos.svemail)" :disabled="edit" :filled="edit"
                                :class="classdisabled"></v-text-field>




                        </v-col>

                    </v-card-text>

                    <v-card-text align="center" class="text-xs-center ma-2"
                        v-if="datos.spaajfhllamajustador == null && vista == 'AJ'">
                        <v-col align="center" class="text-xs-center" md="12">
                            <v-btn color="primary" @click="guardarEdicion()" :disabled="disabledSave">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>

                        </v-col>

                    </v-card-text>

                    <v-card-text align="center" class="text-xs-center ma-2"
                        v-if="datos.spaasfhllamasegurado == null && vista == 'NA'">
                        <v-col align="center" class="text-xs-center" md="12">
                            <v-btn color="primary" @click="guardarEdicion()" :disabled="disabledSave">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>

                        </v-col>

                    </v-card-text>

                    <v-card-text align="center" class="text-xs-center ma-2"
                        v-if="datos.spaabfhllamabogado == null && vista == 'AB'">
                        <v-col align="center" class="text-xs-center" md="12">
                            <v-btn color="primary" @click="guardarEdicion()" :disabled="disabledSave">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>

                        </v-col>

                    </v-card-text>



                </v-form>



            </v-card>
        </v-card>
    </v-flex>


</template>


<script>
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Lideres from "@/services/Lideres/Lideres.service.js";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DataTable
    },
    props: {
        validatermino: false,
        validaConclusion: false,
        svresponsabled: false,
        vista: '',
        datosGrals: [],
    },

    data: () => ({
        editPorque: true,
        editObs: true,
        editCond: true,
        conteoOcupantes: 0,
        disabledSaveOcPas: false,
        showFormOcPas: false,
        errorDelitos: false,
        errorLesiones: '',
        rules: [v => !!v || 'Seleccione alguna opción'],
        errorTelf: [],
        phone: {
            number: null,
            valid: false,
            country: null
        },
        prefijo: null,
        pais: 'MX',
        validOcuPas: true,
        datosOcPas: {
            tipo: null,
            nombre: null,
            numtelf: null,
            lesiones: false,
            lclave: null,
            homicidios: false

        },
        validForm: true,
        datos: {
            //Delitos
            svdpa: false,
            svlesiones: false,
            lclave: null,
            svrobo: false,
            svhomicidios: false,
            svavgc: false,
            //Agravantes
            svebriedad: false,
            svfuga: false,
            svdrogas: false,
            //Tipo Accidente
            svcortedc: false,
            svpreferenciadp: false,
            svpasadada: false,
            pdaclave: null,
            pdatestigos: null,
            pdatestigosexterno: null,
            pdatestigosocupante: null,
            pdacamaras: null,
            pdacamarastransito: null,
            pdacamarasparticular: null,
            svperdidadc: false,
            svinvanciondc: false,
            saincorp: false,
            svalcancecp: false,
            svalcances: false,
            svalcancepa: false,
            svmaniobrasdr: false,
            svatropello: false,
            svotrata: false,
            svotrotaobs: null,
            //Responsabilidad por parte de
            svresponsable: null,
            svdetporque: null,
            //Datos proporcionados
            svcondicionado: false,
            svcondporque: null,
            svmarca: null,
            svcolor: null,
            svlicencia: null,
            svmodelo: null,
            svplaca: null,
            //Monto de daños del vehículo asegurado:
            svdeducible: 0,
            svperdidatotal: 0,
            svestdanosveh: 0,
            dacobertura: null,
            svrevisapoliza: false,
            //Responsabilidad por parte del lider
            sacriteriolider: null,
            sadesclider: null,
            Paclave: null,
            //Datos de homicidio
            datHomicidios: false,
            dhnaocupante: false,
            dhnaocupantenum: 0,
            dh3conductor: false,
            dh3conductornum: 0,
            dh3ocupante: false,
            dh3ocupantenum: 0,
            dh3peaton: false,
            dh3peatonnum: 0,
            ocupantesPas: false,
            copyocupantesPas: false,
            //Datos Ajustador Nuevos
            diferenciaHoras: 0,
            spaajresponsabilidad: null,
            salibNA: null,
            sacondfallecio: null,
            asvip: null,
            satestigos: null,
            saedofisicoNA: null,
            clnombre: null,
            svnumsin: null,
            spaajfhllamajustador: null,
            sahospitalNA: null,
            spaajdetporque: null,

            //DatosNA
            paclaveas: null,
            svemail: null,
            spaasfhllamasegurado: null,
            saresponsable: null,

            spaascortecirc: 0,
            spaasperdcontrol: 0,
            spaasalcancesimple: 0,
            spaasatropello: 0,

            spaascrucero: 0,
            spaasinvcarril: 0,
            spaasotro: 0,
            spaasotrotaobs: null,
            spaasalcancecp: 0,
            spaasmreversa: 0,
            spaaspda: 0,

            spaaspdatestigos: 0,
            spaaspdacamaras: 0,
            spaaspdatestigosocupante: 0,
            spaaspdatestigosexterno: 0,

            spaaspdacamarastransito: 0,
            spaaspdacamarasparticular: 0,
            spaasalcancesa: 0,
            spaastestigo: 0,
            spaaspdaclave: 0,
            pcnombre: null,

            //Datos Abogado
            spaabresponsabilidad: null,
            svconlib: null,
            paclaveab: null,

            spaabcortecirc: 0,
            spaabcrucero: 0,
            spaabpda: 0,
            spaabpdatestigos: 0,
            spaabpdatestigosocupante: 0,
            spaabpdatestigosexterno: 0,
            spaabpdacamaras: 0,
            spaabpdacamarastransito: 0,
            spaabpdacamarasparticular: 0,

            spaabperdcontrol: 0,
            spaabinvcarril: 0,
            spaabalcancecp: 0,
            spaabalcancesimple: 0,
            spaabalcancesa: 0,
            spaabmreversa: 0,
            spaabatropello: 0,
            spaabotros: 0,
            spaabotrotaobs: null,
            spaabdetporque: null,
            spaabpdaclave: null,
            spaabfhllamabogado: null,
            spaabsincondicion: 0,
            saautoridad: null
        },
        datosCopy: {
            //Delitos
            svdpa: false,
            svlesiones: false,
            lclave: null,
            svrobo: false,
            svhomicidios: false,
            svavgc: false,
            //Agravantes
            svebriedad: false,
            svfuga: false,
            svdrogas: false,
            //Tipo Accidente
            svcortedc: false,
            svpreferenciadp: false,
            svpasadada: false,
            pdaclave: null,
            pdatestigos: null,
            pdatestigosexterno: null,
            pdatestigosocupante: null,
            pdacamaras: null,
            pdacamarastransito: null,
            pdacamarasparticular: null,
            svperdidadc: false,
            svinvanciondc: false,
            saincorp: false,
            svalcancecp: false,
            svalcances: false,
            svalcancepa: false,
            svmaniobrasdr: false,
            svatropello: false,
            svotrata: false,
            svotrotaobs: null,
            //Responsabilidad por parte de
            svresponsable: null,
            svdetporque: null,
            //Datos proporcionados
            svcondicionado: false,
            svcondporque: null,
            svmarca: null,
            svcolor: null,
            svlicencia: null,
            svmodelo: null,
            svplaca: null,
            //Monto de daños del vehículo asegurado:
            svdeducible: 0,
            svperdidatotal: 0,
            svestdanosveh: 0,
            dacobertura: null,
            svrevisapoliza: false,
            //Responsabilidad por parte del lider
            sacriteriolider: null,
            sadesclider: null,
            Paclave: null,
            //Datos de homicidio
            datHomicidios: false,
            dhnaocupante: false,
            dhnaocupantenum: 0,
            dh3conductor: false,
            dh3conductornum: 0,
            dh3ocupante: false,
            dh3ocupantenum: 0,
            dh3peaton: false,
            dh3peatonnum: 0,
            ocupantesPas: false,
            copyocupantesPas: false,
            //Datos Ajustador Nuevos
            diferenciaHoras: 0,
            spaajresponsabilidad: null,
            salibNA: null,
            sacondfallecio: null,
            asvip: null,
            satestigos: null,
            saedofisicoNA: null,
            clnombre: null,
            svnumsin: null,
            spaajfhllamajustador: null,
            sahospitalNA: null,
            spaajdetporque: null,

            //DatosNA
            paclaveas: null,
            svemail: null,
            spaasfhllamasegurado: null,
            saresponsable: null,

            spaascortecirc: 0,
            spaasperdcontrol: 0,
            spaasalcancesimple: 0,
            spaasatropello: 0,

            spaascrucero: 0,
            spaasinvcarril: 0,
            spaasotro: 0,
            spaasotrotaobs: 0,
            spaasalcancecp: 0,
            spaasmreversa: 0,
            spaaspda: 0,

            spaaspdatestigos: 0,
            spaaspdacamaras: 0,
            spaaspdatestigosocupante: 0,
            spaaspdatestigosexterno: 0,

            spaaspdacamarastransito: 0,
            spaaspdacamarasparticular: 0,
            spaasalcancesa: 0,
            spaastestigo: 0,
            spaaspdaclave: 0,
            pcnombre: null,

            //Datos Abogado
            spaabresponsabilidad: null,
            svconlib: null,
            paclaveab: null,

            spaabcortecirc: 0,
            spaabcrucero: 0,
            spaabpda: 0,
            spaabpdatestigos: 0,
            spaabpdatestigosocupante: 0,
            spaabpdatestigosexterno: 0,
            spaabpdacamaras: 0,
            spaabpdacamarastransito: 0,
            spaabpdacamarasparticular: 0,

            spaabperdcontrol: 0,
            spaabinvcarril: 0,
            spaabalcancecp: 0,
            spaabalcancesimple: 0,
            spaabalcancesa: 0,
            spaabmreversa: 0,
            spaabatropello: 0,
            spaabotros: 0,
            spaabotrotaobs: null,
            svconlib: 0,
            spaabdetporque: null,
            spaabpdaclave: null,
            spaabfhllamabogado: null,
            spaabsincondicion: 0,
            saautoridad: null
        },
        validation: {
            errorDelitos: false,
            errorLesiones: '',
            errorCrucecon: false,
            errorTestigos: '',
            errorTestigosExtra: false,
            errorCamaras: '',
            errorCamarasExtra: false,
            errorEstDanos: '',
            errorResponsabilidad: '',
            errorLicencia: '',
            errorPlaca: '',
            errorPoliza: '',

            //New
            errorEstadoFisico: '',
            errorConFallecio: '',
            errorEstaDetenido: '',
            errorTipoAseg: '',
            errorHospitalNA: '',
            errorTipoEmpresa: '',
            errorPersonalidad: '',
            errorOtro: '',
            errorResponsabilidadPorque: '',
            errorsvcondporque: '',
        },
        disabledbutton: false,

        disabledSave: false,
        opcionesPasadaAlto: [

        ],
        rulestextarea: [
            v => {
                if (v == null || v == '') {
                    return true
                }
                else {
                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 255) {
                        return "Máximo 255 Carácteres"
                    }
                    else
                        return true
                }
            },
        ],
        rulestextareaCond: [
            v => {
                if (v == null || v == '') {
                    return true
                }
                else {
                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 255) {
                        return "Máximo 255 Carácteres"
                    }
                    else
                        return true
                }
            },
        ],
        rulestextareaDet: [
            v => {
                if (v == null || v == '') {
                    return true
                }
                else {
                    if (v.length < 12) {
                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 255) {
                        return "Máximo 255 Carácteres"
                    }
                    else
                        return true
                }
            },
        ],
        rulesInputsNumberDanios: [(v) => {
            if (v == null || v == '') {
                return 'Inserte un valor valido';
            }
            else {
                if (v < 0 || v > 5000000) {
                    return 'El monto debe ser entre 0 y 5 millones';
                }
                else
                    return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
            }
            return true
        }],

        rulestextareaOtro: [
            v => {

                if (v == null || v == '') {
                    return true;
                }
                else {
                    if (v.length < 12) {

                        return 'Mínimo 12 Carácteres'
                    }
                    else if (v.length > 255) {
                        return "Máximo 255 Carácteres"
                    }
                    else
                        return true
                }
            },


        ],
        rulesInputsNumber: [(v) => {
            if (v == null || v == '') {
                return true;
            }
            else if (v.length > 10) {
                return 'Inserte un valor valido';
            }
            else {
                return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
            }
            return true
        }],

        opcionesCobertura: [
            {
                dacobertura: "Sin Cobertura",
                text: "Sin Cobertura"
            },
            {
                dacobertura: "Amplia",
                text: "Amplia"
            },
            {
                dacobertura: "Limitada",
                text: "Limitada"
            }
        ],
        rulesInputsEmail(value) {
            var resultRules = [];
            if (value == null || value == '') {
                return resultRules
            }
            if (/^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/i.test(value)) return resultRules
            resultRules.push('Correo invalido');
            return resultRules
        },
        urlListado: "ExpJur/ObtenerOcupantesP",
        columns: [
            { name: 'Nombre', data: 'Nombre', title: "Nombre" },
            { name: 'Telefono', data: 'Telefono', title: "Teléfono" },
            { name: 'Tipo', data: 'Tipo', title: "Tipo" },
            { name: 'Lesiones', data: 'Lesiones', title: "Lesión/Homicidio" },
            { name: 'TipoLesiones', data: 'TipoLesiones', title: "Tipo Lesión" }

        ],
        displayInputs: {
            nrreporte: 0,
            svindice: 0
        },
        editAsegurado: false,
        showbuttons: false,
        edit: true,
        classdisabled: "disable-action",
        validacionHoras: 1,
        regex: '',
        mensage: '',
        countHorarios: 0,

        rules: {
            required: value => !!value || 'Campo requerido',

        },

    }),
    watch: {
        'datosOcPas.lesiones'(val) {
            if (!val) {
                this.datosOcPas.lclave = null;
                this.errorLesiones = "";
            }
            else {
                this.datosOcPas.homicidios = false;
                this.errorDelitos = false;
            }
        },
        'datosOcPas.homicidios'(val) {
            if (val) {
                this.datosOcPas.lesiones = false;
                this.errorDelitos = false;
            }
        },
        'datosOcPas.lclave'(val) {
            if (val != null) {
                this.errorLesiones = "";
            }
        },
        'datos.svdpa'(val) {
            if (!val) {
                this.validation.errorEstDanos = "";
            }
            else {
                this.validation.errorDelitos = false;
            }
        },
        'datos.svlesiones'(val) {
            if (!val) {
                this.datos.lclave == null;
                this.validation.errorLesiones = "";
            }
            else {
                this.validation.errorDelitos = false;
            }
        },
        'datos.svrobo'(val) {
            if (val) {
                this.validation.errorDelitos = false;
            }
        },
        'datos.svhomicidios'(val) {
            if (val) {
                this.validation.errorDelitos = false;
            }
        },
        'datos.svavgc'(val) {
            if (val) {
                this.validation.errorDelitos = false;
            }
        },
        'datos.lclave'(val) {
            if (val != null) {
                this.validation.errorLesiones = "";
            }
        },
        'datos.svpasadada'(val) {


            if (this.datos.spaasfhllamasegurado == null) {
                this.datos.spaaspdatestigos = null;
                this.datos.spaaspdacamaras = null;
                this.datos.spaaspdatestigosocupante = null;
                this.datos.spaaspdatestigosexterno = null;
                this.datos.spaaspdacamarastransito = null;
                this.datos.spaaspdacamarasparticular = null;
            }

            if (this.datos.spaajfhllamajustador == null) {
                this.datos.pdatestigos = null;
                this.datos.pdacamaras = null;
                this.datos.pdatestigosocupante = null;
                this.datos.pdatestigosexterno = null;
                this.datos.pdacamarastransito = null;
                this.datos.pdacamarasparticular = null;
            }


            if (this.datos.spaabfhllamabogado == null) {
                this.datos.spaabpdatestigos = null;
                this.datos.spaabpdacamaras = null;
                this.datos.spaabpdatestigosocupante = null;
                this.datos.spaabpdatestigosexterno = null;
                this.datos.spaabpdacamarastransito = null;
                this.datos.spaabpdacamarasparticular = null;
            }

            if (!val) {
                this.validation.errorCrucecon = false;
                this.validation.errorTestigos = "";
                this.validation.errorCamaras = "";
            }
        },

        'datos.svconlib'(val) {
            this.validation.conductor = "";
        },

        'datos.pdaclave'(val) {

            if (this.datos.spaasfhllamasegurado == null) {
                this.datos.spaaspdatestigos = null;
                this.datos.spaaspdacamaras = null;
                this.datos.spaaspdatestigosocupante = null;
                this.datos.spaaspdatestigosexterno = null;
                this.datos.spaaspdacamarastransito = null;
                this.datos.spaaspdacamarasparticular = null;
            }

            if (this.datos.spaajfhllamajustador == null) {
                this.datos.pdatestigos = null;
                this.datos.pdacamaras = null;
                this.datos.pdatestigosocupante = null;
                this.datos.pdatestigosexterno = null;
                this.datos.pdacamarastransito = null;
                this.datos.pdacamarasparticular = null;
            }


            if (this.datos.spaabfhllamabogado == null) {
                this.datos.spaabpdatestigos = null;
                this.datos.spaabpdacamaras = null;
                this.datos.spaabpdatestigosocupante = null;
                this.datos.spaabpdatestigosexterno = null;
                this.datos.spaabpdacamarastransito = null;
                this.datos.spaabpdacamarasparticular = null;
            }


            if (val != null) {
                this.validation.errorCrucecon = false;
            }
        },

        'datos.spaaspda'(val) {

            if (this.datos.spaasfhllamasegurado == null) {
                this.datos.spaaspdatestigos = null;
                this.datos.spaaspdacamaras = null;
                this.datos.spaaspdatestigosocupante = null;
                this.datos.spaaspdatestigosexterno = null;
                this.datos.spaaspdacamarastransito = null;
                this.datos.spaaspdacamarasparticular = null;
            }



            if (val != null) {
                this.validation.errorCrucecon = false;
            }
        },
        'datos.spaabpda'(val) {

            if (this.datos.spaabfhllamabogado == null) {
                this.datos.spaabpdatestigos = null;
                this.datos.spaabpdacamaras = null;
                this.datos.spaabpdatestigosocupante = null;
                this.datos.spaabpdatestigosexterno = null;
                this.datos.spaabpdacamarastransito = null;
                this.datos.spaabpdacamarasparticular = null;
            }



            if (val != null) {
                this.validation.errorCrucecon = false;
            }
        },
        'datos.pdatestigos'(val) {
            if (val != null) {
                this.validation.errorTestigos = "";
            }
            if (val != '1') {
                this.validation.errorTestigosExtra = false;
            }
        },
        'datos.pdacamaras'(val) {
            if (val != null) {
                this.validation.errorCamaras = "";
            }
            if (val != '1') {
                this.validation.errorCamarasExtra = false;
            }
        },

        'datos.pdatestigosocupante'(val) {
            if (val) {
                this.validation.errorTestigosExtra = false;
            }
        },
        'datos.pdatestigosexterno'(val) {
            if (val) {
                this.validation.errorTestigosExtra = false;
            }
        },

        'datos.pdacamarastransito'(val) {
            if (val) {
                this.validation.errorCamarasExtra = false;
            }
        },
        'datos.pdacamarasparticular'(val) {
            if (val) {
                this.validation.errorCamarasExtra = false;
            }
        },



        'datos.spaabpdatestigos'(val) {

            if (val != null) {
                this.validation.errorTestigos = "";
            }
            if (val != '1') {
                this.validation.errorTestigosExtra = false;
            }
        },
        'datos.spaabpdacamaras'(val) {
            if (val != null) {
                this.validation.errorCamaras = "";
            }
            if (val != '1') {
                this.validation.errorCamarasExtra = false;
            }
        },

        'datos.spaabpdatestigosocupante'(val) {
            if (val) {
                this.validation.errorTestigosExtra = false;
            }
        },
        'datos.spaabpdatestigosexterno'(val) {
            if (val) {
                this.validation.errorTestigosExtra = false;
            }
        },

        'datos.spaabpdacamarastransito'(val) {
            if (val) {
                this.validation.errorCamarasExtra = false;
            }
        },
        'datos.spaabpdacamarasparticular'(val) {
            if (val) {
                this.validation.errorCamarasExtra = false;
            }
        },



        'datos.spaaspdatestigos'(val) {

            if (val != null) {
                this.validation.errorTestigos = "";
            }
            if (val != '1') {
                this.validation.errorTestigosExtra = false;
            }
        },
        'datos.spaaspdacamaras'(val) {
            if (val != null) {
                this.validation.errorCamaras = "";
            }
            if (val != '1') {
                this.validation.errorCamarasExtra = false;
            }
        },

        'datos.spaaspdatestigosocupante'(val) {
            if (val) {
                this.validation.errorTestigosExtra = false;
            }
        },
        'datos.spaaspdatestigosexterno'(val) {
            if (val) {
                this.validation.errorTestigosExtra = false;
            }
        },

        'datos.spaaspdacamarastransito'(val) {
            if (val) {
                this.validation.errorCamarasExtra = false;
            }
        },
        'datos.spaaspdacamarasparticular'(val) {
            if (val) {
                this.validation.errorCamarasExtra = false;
            }
        },

        'datos.svestdanosveh'(val) {
            if (val >= 1) {
                this.validation.errorEstDanos = "";
            }
        },

        'datos.spaajresponsabilidad'(val) {

            if (this.vista != "AB") {
                this.validation.errorResponsabilidadPorque = '';

                if (val != null) {

                    this.validation.errorResponsabilidad = "";
                }
                if (val == 'ND') {
                    if (!this.edit) {
                        this.editPorque = false;
                    }



                    if (this.datos.spaajdetporque != null) {

                        this.rulestextareaDet = [];

                        setTimeout(() => {
                            this.rulestextareaDet = [
                                v => {
                                    if (v == '') {
                                        return 'Indicar el tipo de responsabilidad correspondiente'
                                    }
                                    else {
                                        if (v.length < 12) {
                                            return 'Mínimo 12 Carácteres'
                                        }
                                        else if (v.length > 255) {
                                            return "Máximo 255 Carácteres"
                                        }
                                        else
                                            return true
                                    }
                                }]
                        }, 200);
                    }

                }
                else {

                    this.editPorque = true;
                    this.datos.spaajdetporque = null;

                    this.rulestextareaDet = [];
                    setTimeout(() => {
                        this.rulestextareaDet = [
                            v => {
                                if (v == null || v == '') {
                                    return true;
                                }
                                else {
                                    if (v.length < 12) {
                                        return 'Mínimo 12 Carácteres'
                                    }
                                    else if (v.length > 255) {
                                        return "Máximo 255 Carácteres"
                                    }
                                    else
                                        return true
                                }
                            }]
                    }, 200);
                }
            }

        },


        'datos.spaabresponsabilidad'(val) {


            if (this.vista == "AB") {
                this.validation.errorResponsabilidadPorque = '';

                if (val != null) {

                    this.validation.errorResponsabilidad = "";
                }
                if (val == 'ND') {
                    if (!this.edit) {
                        this.editPorque = false;
                    }

                    if (this.datos.spaabdetporque != null) {

                        this.rulestextareaDet = [];

                        setTimeout(() => {
                            this.rulestextareaDet = [
                                v => {
                                    if (v == '') {
                                        return 'Indicar el tipo de responsabilidad correspondiente'
                                    }
                                    else {
                                        if (v.length < 12) {
                                            return 'Mínimo 12 Carácteres'
                                        }
                                        else if (v.length > 255) {
                                            return "Máximo 255 Carácteres"
                                        }
                                        else
                                            return true
                                    }
                                }]
                        }, 200);
                    }



                }
                else {

                    this.editPorque = true;
                    this.datos.spaabdetporque = null;

                    this.rulestextareaDet = [];
                    setTimeout(() => {
                        this.rulestextareaDet = [
                            v => {
                                if (v == null || v == '') {
                                    return true;
                                }
                                else {
                                    if (v.length < 12) {
                                        return 'Mínimo 12 Carácteres'
                                    }
                                    else if (v.length > 255) {
                                        return "Máximo 255 Carácteres"
                                    }
                                    else
                                        return true
                                }
                            }]
                    }, 200);
                }
            }

        },


        'datos.saedofisicoNA'(val) {


            if (this.datos.spaajfhllamajustador == null) {
                this.datos.sahospitalNA = null;
            }

            if (val == null) {

            }
            else {
                this.validation.errorEstadoFisico = "";

            }
        },

        'datos.paclaveab'(val) {



            if (val == null) {

            }
            else {
                this.validation.errorPersonalidad = "";

            }
        },


        'datos.sahospitalNA'(val) {



            if (val == null) {

            }
            else {
                this.validation.errorHospitalNA = "";

            }
        },
        'datos.sacondfallecio'(val) {
            if (val == null) {

            }
            else {
                this.validation.errorConFallecio = "";

            }
        },


        'datos.asvip'(val) {
            if (val == null) {

            }
            else {
                this.validation.errorTipoAseg = "";

            }
        },


        'datos.saresponsable'(val) {
            if (val == null) {

            }
            else {
                this.validation.errorTipoEmpresa = "";

            }
        },


        'datos.paclaveas'(val) {
            if (val == null) {

            }
            else {
                this.validation.errorPersonalidad = "";

            }
        },


        'datos.salibNA'(val) {


            if (val == null) {

            }
            else {
                this.validation.errorEstaDetenido = "";

            }
        },


        'datos.dacobertura'(val) {
            if (val != null) {
                this.validation.errorCobertura = false;
            }
        },


        'datos.svcondporque'(val) {

            this.validation.errorsvcondporque = '';

        },

        'datos.svcondicionado'(val) {

            this.validation.errorsvcondporque = '';

            if (val) {



                if (!this.edit) {
                    this.editCond = false;
                }

                if (this.datos.svcondporque != null) {
                    this.editCond = false;
                }

                if (this.datos.svcondporque != null) {
                    this.rulestextareaCond = [];
                    setTimeout(() => {
                        this.rulestextareaCond = [
                            v => {
                                if (v == '') {
                                    return 'Indicar siniestro condicionado'
                                }
                                else {
                                    if (v.length < 12) {
                                        return 'Mínimo 12 Carácteres'
                                    }
                                    else if (v.length > 255) {
                                        return "Máximo 255 Carácteres"
                                    }
                                    else
                                        return true
                                }
                            }]
                    }, 200);
                }

            }
            else {
                this.editCond = true;
                this.datos.svcondporque = null;
                this.rulestextareaCond = [];
                setTimeout(() => {
                    this.rulestextareaCond = [
                        v => {
                            if (v == null || v == '') {
                                return true
                            }
                            else {
                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);

            }
        },

        'datos.svotrata'(val) {



            this.validation.errorOtro = '';

            if (val) {


                this.datos.svotrotaobs = null;

                var x = this.datos.svotrotaobs;


                if (!this.edit) {
                    this.editObs = false;
                }


                if (x != null) {


                    this.rulestextareaOtro = [];
                    setTimeout(() => {
                        this.rulestextareaOtro = [
                            x => {
                                if (x == '') {
                                    return 'Indicar el tipo de accidente correspondiente a la casilla otro xx'
                                }
                                else {

                                    if (x.length < 12) {
                                        return 'Mínimo 12 Carácteres'
                                    }
                                    else if (x.length > 255) {
                                        return "Máximo 255 Carácteres"
                                    }
                                    else
                                        return true
                                }
                            }]
                    }, 200);
                }

            }
            else {
                this.datos.svotrotaobs = null;
                this.editObs = true;
                this.rulestextareaOtro = [];
                setTimeout(() => {
                    this.rulestextareaOtro = [
                        v => {
                            if (v == null || v == '') {
                                return true
                            }
                            else {
                                // return 'Mínimo 12 Carácteres'

                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);

            }
        },


        'datos.spaasotrotaobs'(val) {

            this.validation.errorOtro = '';

        },

        'datos.svotrotaobs'(val) {

            this.validation.errorOtro = '';

        },

        'datos.spaajdetporque'(val) {

            this.validation.errorResponsabilidadPorque = '';

        },

        'datos.spaabotrotaobs'(val) {

            this.validation.errorOtro = '';

        },

        'datos.spaabdetporque'(val) {

            this.validation.errorResponsabilidadPorque = '';

        },


        'datos.spaasotro'(val) {

            this.datos.spaasotrotaobs = null;

            if (val) {
                if (!this.edit) {
                    this.editObs = false;
                }


                if (this.datos.spaasotrotaobs != null) {


                    this.rulestextareaOtro = [];
                    setTimeout(() => {
                        this.rulestextareaOtro = [
                            x => {
                                if (x == '') {
                                    return 'Indicar el tipo de accidente correspondiente a la casilla otro'
                                }
                                else {

                                    if (x.length < 12) {
                                        return 'Mínimo 12 Carácteres'
                                    }
                                    else if (x.length > 255) {
                                        return "Máximo 255 Carácteres"
                                    }
                                    else
                                        return true
                                }
                            }]
                    }, 200);
                }

            }
            else {
                this.datos.spaasotrotaobs = null;
                this.editObs = true;

                this.rulestextareaOtro = [];
                setTimeout(() => {
                    this.rulestextareaOtro = [
                        v => {
                            if (v == null || v == '') {
                                return true
                            }
                            else {


                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);

            }
        },


        'datos.spaabotros'(val) {

            this.datos.spaabotrotaobs = null;

            if (val) {



                if (!this.edit) {
                    this.editObs = false;
                }


                if (this.datos.spaabotrotaobs != null) {


                    this.rulestextareaOtro = [];
                    setTimeout(() => {
                        this.rulestextareaOtro = [
                            x => {
                                if (x == '') {
                                    return 'Indicar el tipo de accidente correspondiente a la casilla otro'
                                }
                                else {

                                    if (x.length < 12) {
                                        return 'Mínimo 12 Carácteres'
                                    }
                                    else if (x.length > 255) {
                                        return "Máximo 255 Carácteres"
                                    }
                                    else
                                        return true
                                }
                            }]
                    }, 200);
                }
            }
            else {
                this.datos.spaabotrotaobs = null;
                this.editObs = true;

                this.rulestextareaOtro = [];

                setTimeout(() => {
                    this.rulestextareaOtro = [
                        v => {
                            if (v == null || v == '') {
                                return true;
                            }
                            else {
                                if (v.length < 12) {
                                    return 'Mínimo 12 Carácteres'
                                }
                                else if (v.length > 255) {
                                    return "Máximo 255 Carácteres"
                                }
                                else
                                    return true
                            }
                        }]
                }, 200);

            }
        },


        'datos.svlicencia'(val) {
            if (val != null && val != '') {
                this.validation.errorLicencia = '';
            }
        },
        'datos.svrevisapoliza'(val) {
            if (val) {
                this.validation.errorPoliza = '';
            }
        },
        'datos.svplaca'(val) {
            if (val != null && val != '') {
                this.validation.errorPlaca = '';
            }
        },
        'datos.saautoridad'(val) {
            if (val != null && val != '') {
                this.validation.errorAutoridad = '';
            }
        }

    },
    methods: {

        ObtenerRegex(value) {

            var resultRules = [];
            if (this.regex != '') {
                resultRules.push(
                    (v) => new RegExp(this.regex).test(v) || this.mensage
                );
                return resultRules;
            }
            else {
                return true;
            }
        },
        onInput(formattedNumber, { number, valid, country }) {
            if (number.input == number.national) {
                this.errorTelf = [];
                this.phone.number = number.national;
                this.phone.valid = valid;
                this.phone.country = country && country.name;
            }
            else {
                if (this.datosOcPas.numtelf != null && this.datosOcPas.numtelf != '') {
                    this.errorTelf.push("Teléfono Inválido");
                    this.phone.number = number.national;
                    this.phone.valid = false;
                    this.phone.country = country && country.name;
                }
                else {
                    this.errorTelf = [];
                }

            }

        },
        async insertarHorarios() {


            for (const item of this.datosGrals) {

                var resp = await Lideres.InsertarActoresHorario(this.displayInputs, item.Clave, item.Horario);


            }

        },
        async actualizarHorarios() {

            for (const item of this.datosGrals) {

                var resp = await Lideres.InsertarActoresHorario(this.displayInputs, item.Clave, item.Horario);


            }

        },
        async guardarEdicion() {
            this.disabledSave = true;
            this.$refs.form.validate();
            var validHorarios = 0;
            this.validacionHoras = 1;
            this.countHorarios = 0;

            if (this.vista == 'NA') {


                this.datosGrals.forEach((value, index) => {

                    if (value.Existe == 1) {

                        if (value.Horario == null || value.Horario == '') {

                            this.validacionHoras = 0;

                        }
                    }

                    if (value.Horario == null || value.Horario == '') {


                        this.countHorarios = this.countHorarios + 1;
                    }
                });



            }


            if (this.validar() && this.$refs.form.validate()) {


                this.disabledSave = false;
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }


                });


                if (this.vista == 'NA') {
                    await Lideres.ValidarHorarioActor(this.displayInputs.nrreporte, this.displayInputs.svindice).then(response => {


                        validHorarios = response;


                    });


                    if (validHorarios == 2) {
                        var resp = await this.insertarHorarios();
                    }
                    else {
                        var resp = await this.actualizarHorarios();
                    }

                }


                if (this.vista == 'NA') {


                    await Lideres.editarNA(this).then(response => {

                        setTimeout(() => {
                            this.$swal.close();
                            if (response) {
                                for (var clave in this.datos) {
                                    if (this.datosCopy.hasOwnProperty(clave)) {
                                        this.datosCopy[clave] = this.datos[clave];
                                    }
                                }
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se guardaron los datos correctamente',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {


                                    const datosAsegurado = await Lideres.obtenerDatosAsegurado(this);

                                    this.datos.dhnaocupante = datosAsegurado[0].dhnaocupante;
                                    this.datosCopy.dhnaocupante = datosAsegurado[0].dhnaocupante;

                                    this.datos.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;
                                    this.datosCopy.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;

                                    this.datos.datHomicidios = datosAsegurado[0].datHomicidios;
                                    this.datosCopy.datHomicidios = datosAsegurado[0].datHomicidios;


                                    this.disabledSave = false;
                                    this.showbuttons = false;
                                    this.editAsegurado = false;
                                    this.edit = true;
                                    this.classdisabled = 'disable-action';
                                    this.editObs = true;
                                    this.editPorque = true;
                                    this.editCond = true;
                                    this.$emit("reload", true);



                                    this.$router.push({ name: `${"LideresMain"}` }).catch(error => error);


                                });

                            }
                            else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Hubo un error al guardar los datos, Favor de avisar a Desarrollo',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }, 2000);

                    });
                }
                else if (this.vista == 'AB') {
                    await Lideres.editarAB(this).then(response => {

                        setTimeout(() => {
                            this.$swal.close();
                            if (response) {
                                for (var clave in this.datos) {
                                    if (this.datosCopy.hasOwnProperty(clave)) {
                                        this.datosCopy[clave] = this.datos[clave];
                                    }
                                }
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se guardaron los datos correctamente',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {

                                    const datosAsegurado = await Lideres.obtenerDatosAsegurado(this);

                                    this.datos.dhnaocupante = datosAsegurado[0].dhnaocupante;
                                    this.datosCopy.dhnaocupante = datosAsegurado[0].dhnaocupante;

                                    this.datos.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;
                                    this.datosCopy.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;

                                    this.datos.datHomicidios = datosAsegurado[0].datHomicidios;
                                    this.datosCopy.datHomicidios = datosAsegurado[0].datHomicidios;


                                    this.disabledSave = false;
                                    this.showbuttons = false;
                                    this.editAsegurado = false;
                                    this.edit = true;
                                    this.classdisabled = 'disable-action';
                                    this.editObs = true;
                                    this.editPorque = true;
                                    this.editCond = true;
                                    this.$emit("reload", true);



                                    this.$router.push({ name: `${"LideresMain"}` }).catch(error => error);


                                });

                            }
                            else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Hubo un error al guardar los datos, Favor de avisar a Desarrollo',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }, 2000);

                    });
                }
                else {
                    await Lideres.editarAsegurado(this).then(response => {

                        setTimeout(() => {
                            this.$swal.close();
                            if (response) {
                                for (var clave in this.datos) {
                                    if (this.datosCopy.hasOwnProperty(clave)) {
                                        this.datosCopy[clave] = this.datos[clave];
                                    }
                                }
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: 'Se guardaron los datos correctamente',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 2500,
                                }).then(async () => {


                                    const datosAsegurado = await Lideres.obtenerDatosAsegurado(this);

                                    this.datos.dhnaocupante = datosAsegurado[0].dhnaocupante;
                                    this.datosCopy.dhnaocupante = datosAsegurado[0].dhnaocupante;

                                    this.datos.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;
                                    this.datosCopy.dhnaocupantenum = datosAsegurado[0].dhnaocupantenum;

                                    this.datos.datHomicidios = datosAsegurado[0].datHomicidios;
                                    this.datosCopy.datHomicidios = datosAsegurado[0].datHomicidios;


                                    this.disabledSave = false;
                                    this.showbuttons = false;
                                    this.editAsegurado = false;
                                    this.edit = true;
                                    this.classdisabled = 'disable-action';
                                    this.editObs = true;
                                    this.editPorque = true;
                                    this.editCond = true;
                                    this.$emit("reload", true);




                                    this.$router.push({ name: `${"LideresMain"}` }).catch(error => error);


                                });

                            }
                            else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'error',
                                    title: 'Error',
                                    text: 'Hubo un error al guardar los datos, Favor de avisar a Desarrollo',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                })
                            }
                        }, 2000);

                    });
                }




            }
            else {
                this.disabledSave = false;
            }
        },
        validar() {
            let conterror = 0;



            if (this.vista != 'NA') {
                if (!this.datos.svdpa && !this.datos.svlesiones && !this.datos.svrobo && !this.datos.svhomicidios && !this.datos.svavgc) {
                    conterror++;

                    this.validation.errorDelitos = true;
                }
            }

            if (this.datos.svlesiones && this.datos.lclave == null) {
                conterror++;
                this.validation.errorLesiones = "Indique una opción";
            }




            if (this.vista == 'AJ') {
                if (this.datos.svdpa && (this.datos.svestdanosveh == "0.00" || this.datos.svestdanosveh == null || this.datos.svestdanosveh == "" || this.datos.svestdanosveh < 1)) {
                    conterror++;
                    this.validation.errorEstDanos = "Indique Monto Estimado de Daños";
                }
            }




            if (this.vista != 'NA' && this.vista != 'AB') {
                if (this.datos.spaajresponsabilidad == null || this.datos.spaajresponsabilidad == '') {
                    conterror++;
                    this.validation.errorResponsabilidad = "Seleccione el tipo de responsablidad";
                }

            }

            if (this.vista == 'AB') {
                if (this.datos.spaabresponsabilidad == null || this.datos.spaabresponsabilidad == '') {
                    conterror++;
                    this.validation.errorResponsabilidad = "Seleccione el tipo de responsablidad";
                }


                if (this.datos.saautoridad == null || this.datos.saautoridad == '') {
                    conterror++;

                    this.validation.errorAutoridad = "Seleccione el tipo de Autoridad";
                }

                if ((this.datos.spaabdetporque == null || this.datos.spaabdetporque == '') && this.datos.spaabresponsabilidad == 'ND') {

                    conterror++;
                    this.validation.errorResponsabilidadPorque = 'Campo requerido';
                }

                if (this.datos.svconlib == null) {

                    conterror++;
                    this.validation.conductor = 'Campo requerido';
                }


                if (this.datos.spaabpda) {


                    if (this.datos.pdaclave == null) {

                        conterror++;
                        this.validation.errorCrucecon = true;
                    }
                    if (this.datos.spaabpdatestigos == null) {
                        conterror++;



                        this.validation.errorTestigos = "Indique una opción";
                    }
                    if (this.datos.spaabpdacamaras == null) {
                        conterror++;

                        this.validation.errorCamaras = "Indique una opción";
                    }
                    if (this.datos.spaabpdatestigos == '1' && !this.datos.spaabpdatestigosocupante && !this.datos.spaabpdatestigosexterno) {
                        conterror++
                        this.validation.errorTestigosExtra = true;
                    }
                    if (this.datos.spaabpdacamaras == '1' && !this.datos.spaabpdacamarastransito && !this.datos.spaabpdacamarasparticular) {
                        conterror++;

                        this.validation.errorCamarasExtra = true;
                    }
                }

            }

            if (this.vista != 'NA' && this.vista != 'AB') {

                if (this.datos.sacondfallecio == null) {
                    conterror++;
                    this.validation.errorConFallecio = "Indique si el conductor falleció";
                }

                if (this.datos.svpasadada) {
                    if (this.datos.pdaclave == null) {

                        conterror++;
                        this.validation.errorCrucecon = true;
                    }
                    if (this.datos.pdatestigos == null) {
                        conterror++;
                        this.validation.errorTestigos = "Indique una opción";
                    }
                    if (this.datos.pdacamaras == null) {
                        conterror++;
                        this.validation.errorCamaras = "Indique una opción";
                    }
                    if (this.datos.pdatestigos == '1' && !this.datos.pdatestigosocupante && !this.datos.pdatestigosexterno) {
                        conterror++
                        this.validation.errorTestigosExtra = true;
                    }
                    if (this.datos.pdacamaras == '1' && !this.datos.pdacamarastransito && !this.datos.pdacamarasparticular) {
                        conterror++;

                        this.validation.errorCamarasExtra = true;
                    }
                }
            }


            if (this.vista != 'NA' && this.vista != 'AB') {
                if (this.datos.salibNA == null) {
                    conterror++;
                    this.validation.errorEstaDetenido = "Indique si el conductor se encuentra detenido";
                }

                if ((this.datos.spaajdetporque == null || this.datos.spaajdetporque == '') && this.datos.spaajresponsabilidad == 'ND') {

                    conterror++;
                    this.validation.errorResponsabilidadPorque = 'Campo requerido';
                }


                if ((this.datos.svotrotaobs == null || this.datos.svotrotaobs == '') && this.datos.svotrata == true) {

                    conterror++;
                    this.validation.errorOtro = 'Campo requerido';
                }
            }




            if (this.datos.asvip == null) {
                conterror++;


                this.validation.errorTipoAseg = "Seleccione una opción";
            }

            if (this.vista == 'NA') {
                if (this.datos.saresponsable == null || this.datos.saresponsable == '') {
                    conterror++;
                    this.validation.errorTipoEmpresa = "Seleccione una opción";
                }

                if (this.datos.paclaveas == null || this.datos.paclaveas == '') {
                    conterror++;
                    this.validation.errorPersonalidad = "Seleccione una opción";
                }

                if ((this.datos.spaasotrotaobs == null || this.datos.spaasotrotaobs == '') && this.datos.spaasotro == true) {

                    conterror++;

                    this.validation.errorOtro = 'Campo requerido';
                }

                if (this.datos.spaaspda) {
                    if (this.datos.pdaclave == null) {

                        conterror++;
                        this.validation.errorCrucecon = true;
                    }
                    if (this.datos.spaaspdatestigos == null) {
                        conterror++;
                        this.validation.errorTestigos = "Indique una opción";
                    }
                    if (this.datos.spaaspdacamaras == null) {
                        conterror++;
                        this.validation.errorCamaras = "Indique una opción";
                    }
                    if (this.datos.spaaspdatestigos == '1' && !this.datos.spaaspdatestigosocupante && !this.datos.spaaspdatestigosexterno) {
                        conterror++
                        this.validation.errorTestigosExtra = true;
                    }
                    if (this.datos.spaaspdacamaras == '1' && !this.datos.spaaspdacamarastransito && !this.datos.spaaspdacamarasparticular) {
                        conterror++;

                        this.validation.errorCamarasExtra = true;
                    }
                }

            }


            if (this.vista == 'AB') {


                if (this.datos.paclaveab == null || this.datos.paclaveab == '') {


                    conterror++;
                    this.validation.errorPersonalidad = "Seleccione una opción";
                }

                if ((this.datos.spaabotrotaobs == null || this.datos.spaabotrotaobs == '') && this.datos.spaabotros == true) {

                    conterror++;

                    this.validation.errorOtro = 'Campo requerido';
                }

            }


            if (this.vista != 'NA') {
                if ((this.datos.svcondporque == null || this.datos.svcondporque == '') && this.datos.svcondicionado == true) {

                    conterror++;
                    this.validation.errorsvcondporque = 'Campo requerido';
                }
            }



            if (this.vista != 'NA' && this.vista != 'AB') {
                if (this.datos.saedofisicoNA == null || this.datos.saedofisicoNA == '') {
                    conterror++;
                    this.validation.errorEstadoFisico = "Seleccione una opción";
                }
            }


            if (this.datos.sahospitalNA == null && this.datos.saedofisicoNA == 'Lesionado') {
                conterror++;
                this.validation.errorHospitalNA = "Seleccione una opción";
            }

            if (this.datos.dacobertura == null && this.vista == 'AJ') {
                conterror++;
                this.validation.errorCobertura = true;
            }
            if (this.datos.svlicencia == null || this.datos.svlicencia == '') {
                conterror++;
                this.validation.errorLicencia = 'Campo requerido';
            }
            if (this.datos.svplaca == null || this.datos.svplaca == '') {
                conterror++;
                this.validation.errorPlaca = 'Campo requerido';
            }
            if (!this.datos.svrevisapoliza) {
                conterror++;
                this.validation.errorPoliza = 'Favor de validar la póliza';
            }

            if (this.vista == 'NA') {

                if (this.validacionHoras == 0) {


                    this.$emit("reloadHor", true);
                    this.disabledSave = false;
                    return;
                }


            }


            if (this.countHorarios == 3) {

                this.$emit("reloadTels", true);
                return;
            }
            if (conterror > 0) {


                return false;
            } else {

                return true;
            }




        },
        cancelar() {
            for (var clave in this.datosCopy) {
                if (this.datos.hasOwnProperty(clave)) {
                    this.datos[clave] = this.datosCopy[clave];
                }
            }
            this.showbuttons = false;
            this.editAsegurado = false;
            this.edit = true;
            this.classdisabled = 'disable-action';
            this.editObs = true;
            this.editPorque = true;
            this.editCond = true;

            this.validation.errorDelitos = false;
            this.validation.errorLesiones = '';
            this.validation.errorCrucecon = false;
            this.validation.errorTestigos = '';
            this.validation.errorTestigosExtra = false;
            this.validation.errorCamaras = '';
            this.validation.errorCamarasExtra = false;
            this.validation.errorEstDanos = '';
            this.validation.errorResponsabilidad = '';
            this.validation.errorLicencia = '';
            this.validation.errorPlaca = '';
            this.validation.errorPoliza = '';

            this.$refs.form.resetValidation();

        },
        ruleMoney: function ($event, value) {

            if (value == '' || value == null) {
                if ($event.charCode >= 49 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
        ruleMoneyDanios: function ($event, value) {

            if (value == '' || value == null) {
                if ($event.charCode >= 48 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
        cambioPasada() {
            this.datos.pdaclave = null;
            this.datos.pdatestigos = null;
            this.datos.pdatestigosexterno = null;
            this.datos.pdatestigosocupante = null;
            this.datos.pdacamaras = null;
            this.datos.pdacamarastransito = null;
            this.datos.pdacamarasparticular = null;

        },
        cambioTestigos() {
            this.datos.pdatestigosexterno = null;
            this.datos.pdatestigosocupante = null;
        },
        cambioCamaras() {
            this.datos.pdacamarastransito = null;
            this.datos.pdacamarasparticular = null;
        },
        rulesInputs(min, max) {
            var resultRules = [];
            resultRules.push((v) => {
                if (v == null) {
                    return true;
                } else {
                    if (v.trim().length < min) {
                        return "Mínimo " + min + " Carácteres";
                    } else if (v.trim().length > max) {
                        return "Máximo " + max + " Carácteres";
                    } else return true;
                }
            });
            return resultRules;
        },

        uppercase(input) {
            if (input == "svotrotaobs") {
                if (this.datos.svotrotaobs != '' && this.datos.svotrotaobs != null) {
                    this.datos.svotrotaobs = this.datos.svotrotaobs.toUpperCase();
                }
            }
            if (input == "spaajdetporque") {
                if (this.datos.spaajdetporque != '' && this.datos.spaajdetporque != null) {
                    this.datos.spaajdetporque = this.datos.spaajdetporque.toUpperCase();
                }
            }
            if (input == "svcondporque") {
                if (this.datos.svcondporque != '' && this.datos.svcondporque != null) {
                    this.datos.svcondporque = this.datos.svcondporque.toUpperCase();
                }
            }
            if (input == "sadesclider") {
                if (this.datos.sadesclider != '' && this.datos.sadesclider != null) {
                    this.datos.sadesclider = this.datos.sadesclider.toUpperCase();
                }
            }


        },

    },
    async mounted() {


        let datosreporte = await MetodosGenerales.obtenerSessionReporte('reporte');

        this.displayInputs = {
            nrreporte: datosreporte.nrreporte,
            svindice: datosreporte.svindice
        };

        const datosAsegurado = await Lideres.obtenerDatosAsegurado(this);
        await Object.keys(datosAsegurado[0]).map(key => {
            if (typeof datosAsegurado[0][key] == "object") {
                if (this.datos.hasOwnProperty(key)) {
                    this.datos[key] = null;
                }
            } else {
                if (this.datos.hasOwnProperty(key)) {
                    this.datos[key] = datosAsegurado[0][key];
                }
            }
        })

        if (this.datos.svpasadada && this.vista == 'AJ') {

            this.datos.pdaclave = { pdaclave: datosAsegurado[0].pdaclave, pdamotivo: datosAsegurado[0].pdamotivo };
        } else if (this.datos.spaaspdaclave && this.vista == 'NA') {

            this.datos.pdaclave = { pdaclave: datosAsegurado[0].spaaspdaclave, pdamotivo: datosAsegurado[0].pdamotivoNA };
        } else if (this.datos.spaabpdaclave && this.vista == 'AB') {

            this.datos.pdaclave = { pdaclave: datosAsegurado[0].spaabpdaclave, pdamotivo: datosAsegurado[0].pdamotivoAB };
        } else {
            this.datos.pdaclave = null;
        }





        if (this.datos.dacobertura != null && this.datos.dacobertura != '') {
            this.datos.dacobertura = { dacobertura: datosAsegurado[0].dacobertura, text: datosAsegurado[0].dacobertura };
        }

        this.datos.svdeducible = datosAsegurado[0].svdeducible == 0 ? datosAsegurado[0].svdeducible.toFixed(2) : datosAsegurado[0].svdeducible;
        this.datos.svperdidatotal = datosAsegurado[0].svperdidatotal == 0 ? datosAsegurado[0].svperdidatotal.toFixed(2) : datosAsegurado[0].svperdidatotal;
        this.datos.svestdanosveh = datosAsegurado[0].svestdanosveh == 0 ? datosAsegurado[0].svestdanosveh.toFixed(2) : datosAsegurado[0].svestdanosveh;


        if (this.vista == 'AJ') {
            if (this.datos.spaajfhllamajustador == null) {
                this.classdisabled = '';
                this.edit = false;

            } else {
                this.classdisabled = 'disable-action';
                this.edit = true;
            }
        }
        else if (this.vista == 'NA') {



            if (this.datos.spaasfhllamasegurado == null) {
                this.classdisabled = '';
                this.edit = false;

            } else {
                this.classdisabled = 'disable-action';
                this.edit = true;
            }
        }
        else if (this.vista == 'AB') {
            if (this.datos.spaabfhllamabogado == null) {
                this.classdisabled = '';
                this.edit = false;

            } else {
                this.classdisabled = 'disable-action';
                this.edit = true;
            }
        }



        Object.keys(datosAsegurado[0]).map(key => {
            if (typeof datosAsegurado[0][key] == "object") {
                if (this.datosCopy.hasOwnProperty(key)) {
                    this.datosCopy[key] = null;
                }
            } else {
                if (this.datosCopy.hasOwnProperty(key)) {
                    this.datosCopy[key] = datosAsegurado[0][key];
                }
            }
        })
        if (this.datosCopy.svpasadada) {
            this.datosCopy.pdaclave = { pdaclave: datosAsegurado[0].pdaclave, pdamotivo: datosAsegurado[0].pdamotivo };
        }
        if (this.datosCopy.dacobertura != null && this.datosCopy.dacobertura != '') {
            this.datosCopy.dacobertura = { dacobertura: datosAsegurado[0].dacobertura, text: datosAsegurado[0].dacobertura };
        }
        this.datosCopy.svdeducible = datosAsegurado[0].svdeducible == 0 ? datosAsegurado[0].svdeducible.toFixed(2) : datosAsegurado[0].svdeducible;
        this.datosCopy.svperdidatotal = datosAsegurado[0].svperdidatotal == 0 ? datosAsegurado[0].svperdidatotal.toFixed(2) : datosAsegurado[0].svperdidatotal;
        this.datosCopy.svestdanosveh = datosAsegurado[0].svestdanosveh == 0 ? datosAsegurado[0].svestdanosveh.toFixed(2) : datosAsegurado[0].svestdanosveh;

        if (this.vista == 'NA') {
            await Lideres.obtenerPasadaAltoNA(this);
        } else {
            await Lideres.obtenerPasadaAlto(this);
        }

        let formdataPre = new FormData();
        formdataPre.append("nrreporte", this.displayInputs.nrreporte);
        formdataPre.append("svindice", this.displayInputs.svindice);
        var clclave = await General.ObtenerCliente(this, formdataPre);

        let formdata = new FormData();
        formdata.append("nrreporte", this.displayInputs.nrreporte);
        formdata.append("svindice", this.displayInputs.svindice);
        formdata.append("clclave", clclave);



        await General.ValidacionRegex(this, formdata).then(data => {

            this.regex = data[0].regex;
            this.mensage = data[0].mensaje;

        });



    }
}

</script>